export default function initBehavior (){
    document.addEventListener("click", async (event) => {
        const link = event.target.closest(".jsCopyHrefToClipBoardOnClick");

        if (!link) {
            return;
        }

        //event.preventDefault();

        const href = link.href;

        if (!href) {
            return;
        }

        try {
            await navigator.clipboard.writeText(href);
            showCopyPopover(link);
        } catch (err) {
            console.error("Impossible de copier le lien :", err);
        }
    });
}


let copyPopover;

function showCopyPopover(target, message = "Lien copié") {
    if (!copyPopover) {
        copyPopover = document.createElement("div");
        copyPopover.popover = "manual";
        copyPopover.className = "copy-popover";
        document.body.appendChild(copyPopover);
    }

    copyPopover.textContent = message;

    const rect = target.getBoundingClientRect();

    copyPopover.style.left = `${window.scrollX + rect.left + rect.width / 2}px`;
    copyPopover.style.top = `${window.scrollY + rect.top - 10}px`;

    copyPopover.showPopover();

    clearTimeout(copyPopover._timer);
    copyPopover._timer = setTimeout(() => {
        copyPopover.hidePopover();
    }, 1500);
}
